import { render } from "./ChangePhoneModal.vue?vue&type=template&id=25da3d09&lang=pug"
import script from "./ChangePhoneModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangePhoneModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__